import { Injectable } from "@angular/core";
import { DataModel, MetaModel, WidgetModel } from "common/models/utility-models/base-model";
import { FormWidgetService } from "../form-widget.service";
import { UsersMetaModel } from "common/models/page-models/users/users-form-model";
import { UsersModel } from "common/models/page-models/users/user-data-model";
import { UsersFormDataService } from "common/services/data-services/admin/user/users-form-data.services";



@Injectable({
    providedIn: 'root'
})
export class UsersFormWidgetService extends FormWidgetService<UsersModel> {
    constructor(protected ds: UsersFormDataService) {
        super(ds);
    }

    getMetaModel(): MetaModel {
        const meta = new UsersMetaModel();
        return meta.getMetaModel();
    }

    override prepareMetaModel(dataModel: DataModel, metaModel: UsersMetaModel, routeData: WidgetModel): Promise<UsersMetaModel> {
        return new Promise<UsersMetaModel>((resolve, reject) => {
            
            metaModel.pageTitle = dataModel.id !== 0 ?  'Update User' : 'Add User';

            resolve(metaModel);
        });
    }
}
